<template>
  <div class="deposit-container">
    <div class="content">
      <h2>{{ $t("deposit.title") }}</h2>
      <div class="row">
        <div class="processingCards">{{ $t("deposit.processingCards") }}</div>
        <!-- <div class="fee">{{ $t('deposit.fee') }}</div> -->
        <div class="arrow-right"></div>
      </div>

      <InfoRowButton
        v-for="pay in platforms_payments"
        :key="pay"
        :icon="pay.icon"
        :method="traslateLabel(pay.platform)"
        @click="getOption(pay.option)"
      >
      </InfoRowButton>
    </div>

    <p class="method-instructions" v-if="region === 'mena'">
      {{ $t("deposit.textOneMena")
      }}<strong>
        <a href="/cabinet/console/contact_us">{{ $t("deposit.textTwo") }}</a>
      </strong>
      {{ $t("deposit.textThree") }}
      <br />
      <br />
      {{ $t("deposit.textFourMena") }}
    </p>

    <p class="method-instructions" v-else>
      {{ websiteName }} {{ $t("deposit.textOne")
      }}<strong>
        <a @click="getOption('contactus')">{{ $t("deposit.textTwo") }}</a>
      </strong>
      {{ $t("deposit.textThree") }}
      <br />
      <br />
      {{ $t("deposit.textFour") }}
    </p>
  </div>
  <Preloader :showModal="showM"></Preloader>
</template>

<script>
import InfoRowButton from "@/components/InfoRowButton";
import Preloader from "@/components/Preloader";
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from "@vue/runtime-core";
import axios from "axios";
import store from "@/store";
import { i18n } from "@/plugins/i18n";
import { translateText } from "@/plugins/authUtils.js";
export default {
  name: "Deposit",
  components: {
    InfoRowButton,
  },
  data() {
    return {
      pageContact: process.env.VUE_APP_TRADEVIEW_INDEX + "contact",
    };
  },
  methods: {
    getOption(platform) {
      switch (platform) {
        case "alternative":
          this.chooseAlternativeMethods();
          break;
        case "banks":
          this.chooseBank();
          break;
        case "creditcard":
          this.creditCards();
          break;
        case "contactus":
          this.contact();
          break;
      }
    },
    traslateLabel(platform_name) {

        const translationMap = {
          "Credit cards": "deposit.methodOneMena",
          "Alternative methods": "deposit.methodTwo",
          "Bank transfer": "deposit.methodThree"
        };

      return translateText(platform_name, translationMap);
    },
    
    creditCards() {
      this.$router
        .push("/cabinet/console/choose_credit_card")
        .catch((err) => {});
    },
    chooseAlternativeMethods() {
      this.$router
        .push("/cabinet/console/choose_alternative_methods")
        .catch((err) => {});
    },
    chooseBank() {
      this.$router.push("/cabinet/console/choose_banks").catch((err) => {});
    },
    contact() {
      this.$router.push("/cabinet/console/contact_us").catch((err) => {});
    },
    addFunds(target) {
      this.$router
        .push("/cabinet/console/add_funds/" + target)
        .catch((err) => {});
    },
  },
  setup() {
    let imglogo3 = ref("");
    let platforms_payments = ref([]);
    let showM = ref(false);
    // let imglogo4 = ref("")

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    const websiteName = process.env.VUE_APP_CABINET_V2_WEBSITE_NAME;
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    onMounted(() => {
      localStorage.removeItem("platforms_pay");
      let platforms_pay_storage = JSON.parse(
        localStorage.getItem("DepositMethods")
      );
      console.log(platforms_pay_storage);
      if (platforms_pay_storage == null) {
        showM.value = true;
        let _url =
          process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES +
          "/preferences/site";
        let _headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + store.state.token,
        };

        axios({ method: "GET", url: _url, headers: _headers })
          .then((result) => {
            let platforms_pay = result.data.data.platforms_payments;
            localStorage.setItem(
              "DepositMethods",
              JSON.stringify(platforms_pay)
            );
            showM.value = false;
            for (var pay in platforms_pay) {
              switch (pay) {
                case "creditcard":
                  platforms_payments.value[0] = {
                    platform: "Credit cards",
                    icon: "/assets/images/cabinet_bank.svg",
                    option: pay,
                  };
                  break;
                case "alternative":
                  platforms_payments.value[1] = {
                    platform: "Alternative methods",
                    icon: "/assets/images/cabinet_cards.svg",
                    option: pay,
                  };
                  break;
                case "banks":
                  platforms_payments.value[2] = {
                    platform: "Bank transfer",
                    icon: "/assets/images/cabinet_cards.svg",
                    option: pay,
                  };
                  break;
              }
            }
            // console.log(platforms_payments.value);
          })
          .catch((error) => {
            console.log(error);
            showM.value = false;
          });
      } else {
        let platforms_pay = platforms_pay_storage;
        for (var pay in platforms_pay) {
          console.log(platforms_pay);
          switch (pay) {
            case "creditcard":
              platforms_payments.value[0] = {
                platform: "Credit cards",
                icon: "/assets/images/cabinet_cards.svg",
                option: pay,
              };
              break;
            case "alternative":
              platforms_payments.value[1] = {
                platform: "Alternative methods",
                icon: "/assets/images/cabinet_cards.svg",
                option: pay,
              };
              break;
            case "banks":
              platforms_payments.value[2] = {
                platform: "Bank transfer",
                icon: "/assets/images/cabinet_bank.svg",
                option: pay,
              };
              break;
          }
        }
      }
      emitter.on("preferencesUpdated", () => {
        imgSite();
      });
    });

    const imgSite = () => {
      let theme = store.state.preferences.theme;

      if (theme === "LIGHT") {
        imglogo3.value = "/assets/images/logo_zotapay_light.svg";
        // imglogo4.value  = '/assets/images/logo_ecopayz_light.svg'
      }

      if (theme === "DARK") {
        imglogo3.value = "/assets/images/logo_zotapay.svg";
        // imglogo4.value  = '/assets/images/logo_ecopayz.svg'
      }
    };

    imgSite();

    return {
      // imgIcon1,
      // imgIcon2,
      imglogo3,
      showM,
      platforms_payments,
      // imglogo4,
      imgSite,
      websiteName,
      region,
    };
  },
};
</script>

<style scoped>
</style>
